import React from 'react';
import PropTypes from 'prop-types';
import {
  endsSoonLabel,
  isFreeShippingOnly,
  minimumOrderLabel,
  offerLabel,
} from 'ecommerce/lib/coupon';

import PdpIcon from '../product/pdpIcon';
import { Responsive } from '../landing/shared';

// One line for the coupon strip: the offer with its code, or the order minimum while the cart
// has not met it (no code then, the catalog shows full prices until it is met).
const stripCopy = ({ code, summary, previewSummary, coveredProductNames }) => {
  if (!summary || isFreeShippingOnly(summary)) return null;
  const offer = offerLabel(summary, coveredProductNames);
  const ends = endsSoonLabel(summary);
  if (!previewSummary) {
    return { desktop: minimumOrderLabel(summary, coveredProductNames), title: null, ends };
  }
  return {
    desktop: `${offer} with code ${code}, applied at checkout`,
    title: `${offer} with ${code}`,
    ends,
  };
};

// Strip above the hero while a coupon is claimed (docs/coupons.md).
const CouponStrip = ({ claimedCoupon }) => {
  const strip = claimedCoupon.status === 'valid' ? stripCopy(claimedCoupon) : null;
  if (!strip) return null;

  return (
    <div className="gft-coupon" role="status">
      <span className="gft-coupon-icon" aria-hidden="true">
        <PdpIcon name="ticketPercent" size={15} />
      </span>
      <p className="gft-coupon-text">
        <span className="gft-coupon-offer">
          <Responsive desktop={strip.desktop} phone={strip.title} />
        </span>
        <span className="gft-coupon-sub">
          {strip.title && <span className="lnd-phone">Applied at checkout</span>}
          {strip.ends && (
            <span className="gft-coupon-ends">
              <span className="gft-coupon-dot" aria-hidden="true">
                ·
              </span>
              {strip.ends}
            </span>
          )}
        </span>
      </p>
    </div>
  );
};

CouponStrip.propTypes = {
  claimedCoupon: PropTypes.object.isRequired,
};

export default CouponStrip;
